module.exports = __webpack_public_path__ + "static/assets/eb64e706eb7a3b324ba50d3279a980b1.ttf";